const selector = {
    invoicePreview: '.js_action_invoice',
    invoiceModal: '#customer_modal_invoice',
    btnAddCredit: '#btn_add_credit',
    chargeAmount: '#charge_credit_amount',
    preloader: '#preloader',
    preloaderText: '#preloader_text',  
    btnPayBill: '.js_pay_bill',
    modalPayBill: '#modal_pay_bill', 
    paymentAddAlert: '#payment_add_alert',
    btnMakePayment: '#btn_make_payment',
};

export {selector};